import React from 'react';
import classNames from 'classnames';
import config from '../../../config';



const ConditionScaleComponent = (props) => {
  let conditionRating = props.conditionRating;

  if(conditionRating < 0) {
    conditionRating = 0;
  }

  const conditionsToDisplay = config.conditionsData.filter(item=>item.scaleData);
  const currentCondition = conditionsToDisplay.find(condition => {
    return condition.scaleData[props.sellerType] && conditionRating >= condition.scaleData[props.sellerType][0] && conditionRating <= condition.scaleData[props.sellerType][1];
  });
  return <div className="product-condition-scale">
    <div className="bar-chart-title text-bold bot20">Based on your answers:
      {config.getEnvironmentName() !== 'production' &&
        <span data-testid='condition-rating-total' className="left10 green">
          {props.conditionRating}
        </span>
      }
    </div>

    <div className="bar-chart">
      {conditionsToDisplay.map((condition, index) => {
        return (

          <div
            key={index}
            className="bar-segment"
            style={{background: `${condition.scaleData.color}`, height: `${100 / conditionsToDisplay.length}%`}}>

            <div className={classNames('segment-label', {
              'text-bold': currentCondition.label == condition.label
            })}
            >{condition.label}</div>
            <div style={condition.scaleData.promptWrapper} className={classNames('prompt-wrapper --left-side', {
              '--visible-box': currentCondition.label == condition.label
            })}>
              <div style={{ backgroundColor: '#212645' }} className="prompt-box">
                <div style={{ color: '#fff' }}>Current Product Condition</div>
              </div>
              <div style={{ borderBottomColor: '#212645' }} className="triangle"></div>
            </div>
          </div>
        );
      })}
    </div>
  </div>;
};
export default ConditionScaleComponent;